<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>机构管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>机构支付配置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>AdaPay支付配置</span>
        </div>
        <span class="xcx-add left font14" @click="back()">返回列表</span>
      </div>
      <div class="xcx-content">
        <el-form
          ref="form_data"
          :model="form_data"
          :rules="rules"
          label-width="200px"
          style="width: 50%"
        >
          <el-form-item label="商户rsa公钥：" prop="ADAPAY_PUBLIC_RSA">
            <el-input
              type="textarea"
              v-model="form_data.ADAPAY_PUBLIC_RSA"
              placeholder="请输入商户rsa公钥"
            ></el-input>
          </el-form-item>
          <el-form-item label="汇付rsa私钥：" prop="ADAPAY_PRIVATE_RSA">
            <el-input
              type="textarea"
              v-model="form_data.ADAPAY_PRIVATE_RSA"
              placeholder="请输入汇付rsa私钥"
            ></el-input>
          </el-form-item>
          <el-form-item label="APP_ID" prop="ADAPAY_APPID">
            <el-input v-model="form_data.ADAPAY_APPID" placeholder="请输入APP_ID"></el-input>
          </el-form-item>
          <el-form-item label="API_KEY_LIVE" prop="ADAPAY_API_KEY_LIVE">
            <el-input v-model="form_data.ADAPAY_API_KEY_LIVE" placeholder="请输入API_KEY_LIVE"></el-input>
          </el-form-item>
          <!-- <el-form-item label="API_KEY_TEST" prop="ADAPAY_API_KEY_TEST">
            <el-input v-model="form_data.ADAPAY_API_KEY_TEST" placeholder="请输入API_KEY_TEST"></el-input>
          </el-form-item> -->
          <el-form-item class="mar_T_50">
            <el-button type="primary" @click="save()">保存</el-button>
            <el-button type="primary" @click="back()">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      form_data: {
        ADAPAY_PRIVATE_RSA: "",
        ADAPAY_PUBLIC_RSA: "",
        ADAPAY_APPID: "",
        ADAPAY_API_KEY_LIVE: "",
        ADAPAY_API_KEY_TEST: "",
      },
      rules: {
        ADAPAY_PRIVATE_RSA: [
          { required: true, message: "请输入商户rsa公钥", trigger: "blur" },
        ],
        ADAPAY_PUBLIC_RSA: [
          { required: true, message: "请输入汇付rsa私钥", trigger: "blur" },
        ],
        ADAPAY_APPID: [
          { required: true, message: "请输入APP_ID", trigger: "blur" },
        ],
        ADAPAY_API_KEY_LIVE: [
          { required: true, message: "请输入API_KEY_LIVE", trigger: "blur" },
        ],
        ADAPAY_API_KEY_TEST: [
          { required: true, message: "请输入API_KEY_TEST", trigger: "blur" },
        ],
      },
      page: 0,
      count: 0,
      limit: 10,
      id: 0,
      uId: 0,
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    var that = this;
    var query = that.$route.query;
    if (query.uId) {
      that.uId = query.uId;
    }
    if (query.id) {
      that.id = query.id;
      that.getDetail();
    } else {
      that.loading = false;
    }
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios
        .post("/setting/getAdapay", {
          id: that.id,
        }).then((res) => {
          that.form_data = res.data;
          that.loading = false;
        });
    },
    save() {
      const that = this;
      that.$refs.form_data.validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.form_data;
        var url = "/manage/store";
        if (that.id) {
          formData.id = that.id;
          url = "/setting/adapay";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.uId ? "修改成功" : "添加成功");
          that.back();
        });
      });
    },
    back() {
      var that = this;
      that.$router.push({
        path: "/manage/setting",
        query: {
          id: that.uId,
        },
      });
    },
  },
};
</script>
<style>
</style>